import React, { createContext, useEffect, useState } from "react";
import { Card, Button, Form, Input, Row, Col } from "antd";
import Connection from "./Hook/Connection";
import Publisher from "./Hook/Publisher";
import Subscriber from "./Hook/Subscriber";
import Receiver from "./Hook/Receiver";
//import mqtt from 'mqtt';
import mqtt from "precompiled-mqtt";

export const QosOption = createContext([]);
const qosOption = [
  {
    label: "0",
    value: 0,
  },
  {
    label: "1",
    value: 1,
  },
  {
    label: "2",
    value: 2,
  },
];

const Header = () => {
  const [client, setClient] = useState(null);
  const [isSubed, setIsSub] = useState(false);
  const [payload, setPayload] = useState({});
  const [connectStatus, setConnectStatus] = useState("Connect");

  const [isCheckedPub_Suscr, setIsCheckedPub_Suscr] = useState(false);
  const [isCheckedConnection, setIsCheckedConnection] = useState(false);
  const [isCheckedReceiver, setIsCheckedReceiver] = useState(false);
  
  const handleOnChangePub_Suscr = () => {
    setIsCheckedPub_Suscr(!isCheckedPub_Suscr);
  };

  const handleOnChangeConnection = () => {
    setIsCheckedConnection(!isCheckedConnection);
  };

  const handleOnChangeReceiver = () => {
    setIsCheckedReceiver(!isCheckedReceiver);
  };

  //   const conectar = (values) => {
  //     const { protocol, host, clientId, port, path, username, password } = values;
  const conectarHttps = () => {
    // const { protocol, host, clientId, port, path, username, password } = values;
    var host = "boxdin.ddns.net";
    // var host= "localhost";
    var port = 15676;
    // var port= 15675;
    const url = `ws://${host}:${port}/ws`;
    const options = {
      //   protocol: "ws",
      protocol: "wss",
      clientId: `mqttjs_ + ${Math.random().toString(16).substr(2, 8)}`,
      path: "/ws",
      //   username: "",
      //   password: "",
      keepalive: 30,
      protocolVersion: 4,
      clean: true,
      reconnectPeriod: 1000,
      connectTimeout: 30 * 1000,
      will: {
        topic: "WillMsg",
        payload: "Connection Closed abnormally..!",
        qos: 0,
        retain: false,
      },
      rejectUnauthorized: false,
    };
    // options.protocol = protocol;
    // options.clientId = clientId;
    // options.username = username;
    // options.password = password;
    // options.path = path;
    // connect(url, options);
    mqttConnect(url, options);
  };

  const conectarLocal = () => {
    var host= "localhost";
    var port = 15675;
    const url = `ws://${host}:${port}/ws`;
    const options = {
      protocol: "ws",
      clientId: `mqttjs_ + ${Math.random().toString(16).substr(2, 8)}`,
      path: "/ws",
      //   username: "",
      //   password: "",
      keepalive: 30,
      protocolVersion: 4,
      clean: true,
      reconnectPeriod: 1000,
      connectTimeout: 30 * 1000,
      will: {
        topic: "WillMsg",
        payload: "Connection Closed abnormally..!",
        qos: 0,
        retain: false,
      },
      rejectUnauthorized: false,
    };
    mqttConnect(url, options);
  };

  const mqttConnect = (host, mqttOption) => {
    console.log(host);
    console.log(mqttOption);
    setConnectStatus("Connecting");
    setClient(mqtt.connect(host, mqttOption));
  };

  const mqttDisconnect = () => {
    if (client) {
      client.end(() => {
        setConnectStatus("Connect");
      });
    }
  };

  useEffect(() => {
    if (client) {
      client.on("connect", () => {
        setConnectStatus("Connected");
      });
      client.on("error", (err) => {
        console.error("Connection error: ", err);
        client.end();
      });
      client.on("reconnect", () => {
        setConnectStatus("Reconnecting");
      });
      client.on("message", (topic, message) => {
        const payload = { topic, message: message.toString() };
        setPayload(payload);
        console.log(payload);
        document.dispatchEvent(
          new CustomEvent("mqtt1Rx1", {
            bubbles: true,
            detail: {
              topic: topic,
              message: message.toString(),
            },
          })
        );
      });
    }
  }, [client]);

  const mqttPublish = (context) => {
    if (client) {
      const { topic, qos, payload } = context;
      client.publish(topic, payload, { qos }, (error) => {
        if (error) {
          console.log("Publish error: ", error);
        }
      });
    }
  };

  const mqttSub = (subscription) => {
    if (client) {
      const { topic, qos } = subscription;
      client.subscribe(topic, { qos }, (error) => {
        if (error) {
          console.log("Subscribe to topics error", error);
          return;
        }
        setIsSub(true);
      });
    }
  };

  const mqttUnSub = (subscription) => {
    if (client) {
      const { topic } = subscription;
      client.unsubscribe(topic, (error) => {
        if (error) {
          console.log("Unsubscribe error ", error);
          return;
        }
        setIsSub(false);
      });
    }
  };

  return (
    <>
      <div> -Status:{connectStatus} -
      {/* <h1>This is heading 1</h1> */}
      {/* <Button type="primary" onClick={conectarHttps}>https: {connectStatus}</Button>, */}
      <Button type="primary" onClick={conectarHttps}>https:</Button>-
        <Button type="primary" onClick={conectarLocal}>http Local:</Button>-
        <Button danger onClick={mqttDisconnect}>Desconectar</Button>-
        {/* <Button type="primary" onClick={conectarLocal}>Suscribir: #</Button> - */}
        <input type="checkbox" id="Connection" name="Connection" value="Connection" 
        checked={isCheckedConnection} onChange={handleOnChangeConnection}/>Connection {isCheckedConnection ? "si" : "no"}  -- 
        <input type="checkbox" id="Pub_Suscr" name="Pub_Suscr" value="Pub_Suscr" 
        checked={isCheckedPub_Suscr} onChange={handleOnChangePub_Suscr}/>Pub_Suscr {isCheckedPub_Suscr ? "si" : "no"}  --
        <input type="checkbox" id="Receiver" name="Receiver" value="Receiver" 
        checked={isCheckedReceiver} onChange={handleOnChangeReceiver}/>Receiver {isCheckedReceiver ? "si" : "no"}
        </div>
        {isCheckedConnection && (<Connection connect={mqttConnect} disconnect={mqttDisconnect} connectBtn={connectStatus}/>)}
        {isCheckedPub_Suscr && (
      <QosOption.Provider value={qosOption}>
        <Subscriber sub={mqttSub} unSub={mqttUnSub} showUnsub={isSubed} />
        <Publisher publish={mqttPublish} />
      </QosOption.Provider>)} 

      {isCheckedReceiver && (<Receiver payload={payload}/>)}

    </>
  );
};

export default Header;
